import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-657e7db7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("可接单")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("不可接单")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("重置搜索")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("评分：")
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 8,
  class: "action_btn_box"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("上报司机信息")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_ImageView = _resolveComponent("ImageView")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_DriverSet = _resolveComponent("DriverSet")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "司机管理",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "inline" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "接单状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.searches.idle,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.idle) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch('idle', $event, $event))),
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.searches.disable,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searches.disable) = $event)),
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSearch('disable', $event, $event))),
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "实名认证" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.searches.vali_real_name,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searches.vali_real_name) = $event)),
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSearch('vali_real_name', $event, $event))),
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "驾驶证认证" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.searches.vali_driver,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searches.vali_driver) = $event)),
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSearch('vali_driver', $event, $event))),
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_tooltip, null, {
                  title: _withCtx(() => [
                    _hoisted_13
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "dashed",
                      onClick: _ctx.resetSearch
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'head_img')
          ? (_openBlock(), _createBlock(_component_ImageView, {
              key: 0,
              "image-url": text
            }, null, 8, ["image-url"]))
          : _createCommentVNode("", true),
        (column.key === 'approve')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("a", {
                style: _normalizeStyle({color: record.vali_real_name ? '#00ab00' : '#ff0000'})
              }, "实名认证：" + _toDisplayString(record.vali_real_name ? '已认证' : '未认证'), 5),
              _hoisted_15,
              _createElementVNode("a", {
                style: _normalizeStyle({color: record.vali_driver ? '#00ab00' : '#ff0000'})
              }, "驾驶证认证：" + _toDisplayString(record.vali_driver ? '已认证' : '未认证'), 5),
              _hoisted_16,
              _createElementVNode("a", {
                style: _normalizeStyle({color: record.vali_vehicle ? '#00ab00' : '#ff0000'})
              }, "行驶证认证：" + _toDisplayString(record.vali_vehicle ? '已认证' : '未认证'), 5)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'gender')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(text === 1 ? '男' : text === 2 ? '女' : '保密'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'favorites_num')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", null, [
                _hoisted_17,
                (record.consignment_total > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString((record.stars_total / record.consignment_total).toFixed(2)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_19, "5"))
              ]),
              _createElementVNode("div", null, "点赞数：" + _toDisplayString(text), 1),
              _createElementVNode("div", null, "总订单数：" + _toDisplayString(record.consignment_total), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'income')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createTextVNode(_toDisplayString(_ctx.amountFormat(text)), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'balance')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createTextVNode(_toDisplayString(_ctx.amountFormat(text)), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'idle')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
              _createTextVNode(_toDisplayString(text ? '可接单' : '不可接单'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'disable')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
              _createTextVNode(_toDisplayString(text ? '已禁用' : '启用'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_a_popconfirm, {
                title: record.disable ? '确定启用吗?' : '确定禁用吗?',
                "ok-text": "确定",
                "cancel-text": "取消",
                onConfirm: ($event: any) => (_ctx.onSetStatus(record))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    size: "small",
                    class: "action_btn",
                    danger: record.disable === 0,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(record.disable ? '启用' : '禁用'), 1)
                    ]),
                    _: 2
                  }, 1032, ["danger"])
                ]),
                _: 2
              }, 1032, ["title", "onConfirm"]),
              _createVNode(_component_a_button, {
                size: "small",
                class: "action_btn",
                onClick: ($event: any) => (_ctx.setVisible(record, true))
              }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_a_popconfirm, {
                title: "确定上报司机信息吗?",
                "ok-text": "确定",
                "cancel-text": "取消",
                onConfirm: ($event: any) => (_ctx.updateDriver(record))
              }, {
                default: _withCtx(() => [
                  (record.is_pushed === 0)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        size: "small",
                        class: "action_btn",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.visible) = $event)),
      title: "编辑司机",
      footer: null,
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setVisible(undefined, false)))
    }, {
      default: _withCtx(() => [
        (_ctx.editItem)
          ? (_openBlock(), _createBlock(_component_DriverSet, {
              "edit-item": _ctx.editItem,
              key: _ctx.editItem?.id,
              reset: _ctx.onClose
            }, null, 8, ["edit-item", "reset"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}